import { api } from './api';
export const topicsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 获取选题列表
        getTopics: builder.query({
            query: (params) => ({
                url: '/topics',
                params,
            }),
            providesTags: (result) => result
                ? [
                    ...result.items.map(({ id }) => ({ type: 'Topic', id })),
                    { type: 'Topic', id: 'LIST' },
                ]
                : [{ type: 'Topic', id: 'LIST' }],
        }),
        // 获取单个选题详情
        getTopic: builder.query({
            query: (id) => `/topics/${id}`,
            providesTags: (result, error, id) => [{ type: 'Topic', id }],
        }),
        // AI推荐选题
        getAIRecommendations: builder.mutation({
            query: (params) => ({
                url: '/topics/ai-recommend',
                method: 'POST',
                body: params,
            }),
        }),
        // AI深度分析选题
        analyzeTopic: builder.mutation({
            query: (id) => ({
                url: `/topics/${id}/analyze`,
                method: 'POST',
            }),
        }),
    }),
});
export const { useGetTopicsQuery, useGetTopicQuery, useGetAIRecommendationsMutation, useAnalyzeTopicMutation, } = topicsApi;
